import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../shared/shared.module';
import { CouponFormComponent } from './coupon-form.component';
import { CouponFormRoutingModule } from './coupon-form-routing.module';
import { CouponFormResolve } from './coupon-form.resolve';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    CouponFormRoutingModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatRadioModule,
    ReactiveFormsModule,
  ],
  declarations: [CouponFormComponent],
  entryComponents: [],
  exports: [CouponFormComponent],
  providers: [CouponFormResolve],
})
export class CouponFormModule {}
